// Libs
import React, { useContext, useState } from 'react';
// Config
import { ModalBuilderConfig } from 'core/ModalBuilder';
// Context
import { ModalBuilderContext } from 'core/context';
// Components
import { Button, Span, Wrapper } from 'components';

const WarehousePackageIdValue = ({ field, rowData, stateTable }) => {
	const { setModal } = useContext(ModalBuilderContext);
	const modalKeys = ModalBuilderConfig.getAuthorizedModalKeys();

	const handlePakage = () => {
		setModal(modalKeys.transactionNewPackage, {
			stateTable: stateTable.data,
			getData: stateTable.getData,
			wtdiId: rowData.id,
			transactionId: rowData.wtdId,
		});
	};

	if (rowData.warehouse_package_id)
		return (
			<Wrapper>
				<Span maxHeight='200px' overflow='auto'>
					{rowData.warehouse_package_id}
				</Span>
			</Wrapper>
		);

	return (
		<Wrapper>
			{field?.disableCreatePackage ? (
				<Span />
			) : (
				<Button
					onClick={e => {
						e.stopPropagation();
						handlePakage();
					}}
				>
					Nuevo
				</Button>
			)}
		</Wrapper>
	);
};

export default WarehousePackageIdValue;
